// Mintegral 크리에이티브측 블록 — 타사 정식 Luna mintegral 빌드에서 그대로 추출.
// mintegral.html · mintegral2.html · mintegral3.html (Royal Match / XP Hero /
// Royal Kingdom, buildId 16104518 / 17409864 / 16407749) 에서 바이트가 동일하다.
//
// Mintegral 재생 계약은 양쪽이 나눠 갖는다:
//   · 크리에이티브가 정의 → gameStart, gameClose        (SDK가 호출한다)
//   · 호스트가 정의       → install, gameReady, gameEnd, MW_INIT, MW_CONFIG
// 아래 블록들은 앞의 절반이다. 뒤의 절반(SDK 본체 · MW_CONFIG · rayjump 로더 ·
// 오디오 패치 · body mark="mobvista")은 Mintegral이 송출할 때 붙이므로 변환에서
// 만들지 않는다 — 근거: 세 파일의 Luna 빌드 지문(pi 블록 · buildId)이 서로 다른데
// SDK 블록은 바이트까지 같고, SDK는 MW_CONFIG를 읽기만 하며(쓰기 0회), MW_INIT은
// 파일 어디에도 없이 play.rayjump.com/util/m_util.js 에서 오고, 로더가 송출
// 시점에만 존재하는 URL 쿼리(plDns · mw_test)를 읽는다.
//
// 호스트 API는 전부 방어적으로 부른다(window.install && window.install()) —
// SDK가 없는 환경에서도 깨지지 않는다.
//
// 손으로 고치지 말 것 — 참조 빌드에서 다시 떠오는 것이 유일한 갱신 방법이다.

// mraid 생명주기 블록을 대체한다. 로드되면 곧바로 멈춘 채 대기하다가 SDK가
// window.gameStart()를 부르면 재개한다 — 재생 시점의 주도권이 SDK로 넘어간다.
// md5 4310c72d, 334 B
export const MINTEGRAL_LIFECYCLE = "window.addEventListener(\"luna:build\",(()=>{window.pi.logLoaded(),window.dispatchEvent(new Event(\"luna:unsafe:pause\")),window.dispatchEvent(new Event(\"luna:start\"))})),window.addEventListener(\"luna:started\",(()=>{window.gameReady&&window.gameReady()})),window.gameStart=function(){window.dispatchEvent(new Event(\"luna:unsafe:resume\"))}";

// mraid CTA 블록을 대체한다. 스토어 이동을 직접 열지 않고 호스트의 install()에
// 맡긴다. gameClose는 SDK가 광고를 닫을 때 부르는 콜백이다.
// md5 48b2c35b, 321 B
export const MINTEGRAL_CTA = "window.gameClose=function(){window.dispatchEvent(new Event(\"luna:pause\"))},window.addEventListener(\"luna:build\",(()=>{Bridge.ready((()=>{Luna.Unity.Playable.InstallFullGame=function(){window.pi.logCta(),window.install&&window.install()}}))})),window.addEventListener(\"luna:ended\",(()=>{window.gameEnd&&window.gameEnd()}))";

// mraid.getMraidAdData() 대신 MW_INIT.isRewardAds()로 리워드 여부만 기록한다.
// md5 ef0d2785, 235 B
export const MINTEGRAL_AD_DATA = "window.pi.injectAdData=function(){if(window.MW_INIT)try{const i=window.MW_INIT.isRewardAds();!0===i?this.env.isRewarded=1:!1===i&&(this.env.isRewarded=0)}catch(i){console.warn(\"Mintegral is not available, skipping ad data injection\")}}";
